import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { Icon } from "../lib/Icon";
import { ErrorNote, Loading, Page } from "./common";

const KIND_ICON: Record<string, string> = { Article: "book-open", PDF: "book", Video: "play" };

export function Knowledge() {
  const kb = useQuery({ queryKey: ["kb"], queryFn: api.kb });
  const macros = useQuery({ queryKey: ["macros"], queryFn: api.macros });
  if (kb.isLoading || macros.isLoading) return <Loading />;
  if (kb.error) return <ErrorNote error={kb.error} />;
  if (macros.error) return <ErrorNote error={macros.error} />;

  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Knowledge & macros</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Articles and reply macros used across every client</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(360px,1fr))", gap: 16 }}>
        <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", overflow: "hidden" }}>
          <div style={{ padding: "15px 18px 10px", fontSize: 15, fontWeight: 600 }}>Articles</div>
          {(kb.data ?? []).map((k) => (
            <Link key={k.id} to="/kb/$articleId" params={{ articleId: k.id }} style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 18px", borderTop: "1px solid #f4f3ee", textDecoration: "none", color: "inherit" }}>
              <span style={{ width: 26, height: 26, borderRadius: 5, background: "#e8f4ee", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                <Icon name={KIND_ICON[k.kind] ?? "book-open"} size={13} color="#006747" />
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>{k.title}</div>
                <div style={{ fontSize: 11, color: "#8a8e88" }}>{k.scope} · updated {k.updated}</div>
              </div>
              <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 11.5, color: "#8a8e88" }}>{k.views.toLocaleString()}</span>
            </Link>
          ))}
        </div>
        <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", overflow: "hidden" }}>
          <div style={{ padding: "15px 18px 10px", fontSize: 15, fontWeight: 600 }}>Macros</div>
          {(macros.data ?? []).map((m) => (
            <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 18px", borderTop: "1px solid #f4f3ee" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>{m.name}</div>
                <div style={{ fontSize: 11, color: "#8a8e88" }}>{m.category}</div>
              </div>
              <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 11.5, color: "#8a8e88" }}>{m.uses.toLocaleString()} uses</span>
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
}
